import{__require as r}from"./indexed-object.js";import{__require as e}from"./require-object-coercible.js";var i,o;function t(){if(o)return i;o=1;var t=r(),u=e();return i=function(r){return t(u(r))}}export{t as __require};
//# sourceMappingURL=to-indexed-object.js.map
